import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  root: {
    padding: '8px',
    resize: 'none',
    borderRadius: 8,
  },
});
